export default {
    data: function() {
        return {
            mixKeyCodes: {
                '112': 'f1',
                '113': 'f2',
                '114': 'f3',
                '115': 'f4',
                '116': 'f5',
                '117': 'f6',
                '118': 'f7',
                '119': 'f8',
                '120': 'f9',
                '121': 'f10',
                '122': 'f11',
                '123': 'f12',
            },
            bindings: {},
        }
    },
    methods: {
        mixGetKey() {
            const ss = this
            document.addEventListener('keydown', function(e) {
                const code = e.keyCode
                if (code >= 112 && code <= 123) {
                    e.preventDefault()
                    ss.bindings[ss.mixKeyCodes[code]]()
                }
            })
        },
    },
    mounted() {
        this.mixGetKey()
    },
}
